import { useTranslation } from 'react-i18next';

import { Body1, Button } from '@myphx-engineering/phx-design-system';

export type PriorAuthNextStepsProps = {
    prescriberPhone: string | null | undefined;
};

export const PriorAuthNextSteps = ({
    prescriberPhone,
}: PriorAuthNextStepsProps) => {
    const { t } = useTranslation('lilly');

    return (
        <>
            <Body1>{t('orderConfirmation.nextSteps.priorAuth.line1')}</Body1>
            <Body1 bold>
                {t('orderConfirmation.nextSteps.priorAuth.line2')}
            </Body1>
            {prescriberPhone && (
                <Button
                    onClick={() => {
                        window.location.href = `tel:${prescriberPhone}`;
                    }}
                >
                    {t('orderConfirmation.nextSteps.priorAuth.callProvider')}
                </Button>
            )}
        </>
    );
};
